/* ============================================================
   VD · VOLET PRODUIT — aperçu au clic depuis une carte
   ------------------------------------------------------------
   Objectif métier : sur une page collection, un client doit
   pouvoir comparer les formats d'un produit et l'ajouter au
   panier sans quitter la grille. Le point dur des gousses de
   vanille, c'est le PRIX A LA GOUSSE : il n'est écrit nulle
   part, et c'est lui qui rend la gamme lisible. On le calcule
   ici, à partir du nombre de gousses lu dans le nom de la
   variante, et on marque le format le plus avantageux.

   Contraintes respectées :
   · aucune librairie externe ;
   · aucun appel réseau : les variantes sont déjà dans la page,
     déposées en JSON par snippets/vd-volet-data.liquid ;
   · l'ajout au panier passe par un <form action="/cart/add">
     classique, donc par le gestionnaire global de vd-yc.js :
     le tiroir panier s'ouvre et se rafraîchit tout seul, aucune
     logique de panier n'est dupliquée ici ;
   · prefers-reduced-motion géré par le CSS.
   ============================================================ */
(function () {
  'use strict';

  var racine = null;      // l'élément .vd-volet
  var refs = {};          // ses sous-éléments, résolus une fois
  var courant = null;     // le produit affiché
  var choisi = null;      // la variante sélectionnée
  var declencheur = null; // le bouton qui a ouvert le volet (retour du focus)
  var scrollY = 0;

  /* -------------------------------------------------- utilitaires */

  function texte(v) {
    var d = document.createElement('div');
    d.textContent = v == null ? '' : String(v);
    return d.innerHTML;
  }

  /* Le format monétaire de la boutique est déposé sur le volet par Liquid.
     On ne devine pas : sans lui, on retombe sur un affichage neutre. */
  function argent(cents) {
    var f = (racine && racine.getAttribute('data-money-format')) || '';
    var val = (cents / 100).toFixed(2);
    if (/\{\{\s*amount\s*\}\}/.test(f)) {
      return f.replace(/\{\{\s*amount\s*\}\}/, val.replace('.', ','));
    }
    if (/\{\{\s*amount_no_decimals\s*\}\}/.test(f)) {
      return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
    }
    if (/\{\{\s*amount_with_comma_separator\s*\}\}/.test(f)) {
      return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, val.replace('.', ','));
    }
    return val.replace('.', ',') + ' €';
  }

  /* Nombre de gousses lu dans le nom de la variante.
     « 10 gousses » → 10 · « S (10-12 cm) · 10 gousses » → 10.
     Retourne 0 quand la variante ne se compte pas en gousses (poudre,
     extrait, coffret, conditionnement au poids) : dans ce cas aucun prix
     unitaire n'est affiché.

     Miroir de snippets/vd-compte-gousses.liquid : DÉTECTION STRUCTURELLE,
     jamais par un mot de langue. Shopify TRADUIT les noms de variantes, et
     pas avec le même mot d'une fiche à l'autre. La liste française
     « gousse, bean, pod, clove, vaina » rendait 0 en allemand
     (« 10 Vanilleschoten »), en italien (« 10 baccelli di vaniglia ») et en
     néerlandais (« 10 vanillestokjes »).

     Ce qui ne se traduit pas : la forme « nombre + mot », les séparateurs
     « / » et « · », et les unités de mesure. On garde le dernier segment,
     on écarte les longueurs (cm, mm : c'est un calibre) puis les masses et
     volumes (g, kg, ml... : c'est un conditionnement au poids), et on lit
     le premier nombre de ce qui reste. L'attribut data-mots-gousse n'est
     plus lu ; il reste posé par le Liquid, sans effet. */
  var UNITES_POIDS = ['g', 'kg', 'mg', 'ml', 'cl', 'l', 'oz', 'lb'];
  function gousses(nom) {
    var s = String(nom || '').toLowerCase();
    s = s.split('/').pop();
    s = s.split('·').pop().trim();
    if (s.indexOf('cm') !== -1 || s.indexOf('mm') !== -1) return 0;
    var mots = s.split(/\s+/).filter(Boolean);
    for (var i = 0; i < mots.length; i++) {
      var n = parseInt(mots[i], 10);
      if (!isNaN(n) && n > 0) {
        var suivant = (mots[i + 1] || '').trim();
        return UNITES_POIDS.indexOf(suivant) === -1 ? n : 0;
      }
    }
    return 0;
  }

  /* ------------------------------------------------------ rendu */

  function rendreOptions(produit) {
    var vs = produit.variants || [];

    /* Meilleur prix à la gousse parmi les variantes DISPONIBLES et
       comptées en gousses. On ne décore rien si le produit n'a qu'un
       seul format compté, la mention n'apprendrait rien. */
    var comptees = vs.filter(function (v) { return v.available && gousses(v.title) > 0; });
    var meilleur = null;
    if (comptees.length > 1) {
      comptees.forEach(function (v) {
        var u = v.price / gousses(v.title);
        if (meilleur === null || u < meilleur.u) meilleur = { u: u, id: v.id };
      });
    }

    return vs.map(function (v, i) {
      var n = gousses(v.title);
      var lignes = [];
      if (n > 0) lignes.push(argent(Math.round(v.price / n)) + ' ' + refs.motGousse);
      if (!v.available) lignes.push(refs.motRupture);
      var badge = (meilleur && meilleur.id === v.id && v.available)
        ? '<span class="vd-volet__tag">' + texte(refs.motMeilleur) + '</span>'
        : '';

      return '' +
        '<label class="vd-volet__opt' + (!v.available ? ' is-out' : '') + '" data-vd-volet-opt="' + v.id + '">' +
          '<input type="radio" name="vd-volet-variante" value="' + v.id + '"' +
            (v.available ? '' : ' disabled') + (i === 0 && v.available ? ' checked' : '') + '>' +
          '<span class="vd-volet__opt-name">' + texte(v.title) + '</span>' +
          '<span class="vd-volet__opt-price">' + argent(v.price) + '</span>' +
          (lignes.length || badge
            ? '<span class="vd-volet__opt-unit">' + badge + '<span>' + texte(lignes.join(' · ')) + '</span></span>'
            : '') +
        '</label>';
    }).join('');
  }

  function selectionner(id) {
    if (!courant) return;
    var v = null;
    for (var i = 0; i < courant.variants.length; i++) {
      if (String(courant.variants[i].id) === String(id)) { v = courant.variants[i]; break; }
    }
    if (!v || !v.available) return;
    choisi = v;
    refs.champId.value = v.id;
    refs.ajouter.disabled = false;
    refs.ajouter.textContent = refs.motAjouter;
    Array.prototype.forEach.call(racine.querySelectorAll('[data-vd-volet-opt]'), function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-vd-volet-opt') === String(v.id));
    });
  }

  /* ---------------------------------------------- ouverture / fermeture */

  function ouvrir(produit, bouton) {
    if (!racine) return;
    courant = produit;
    declencheur = bouton || null;

    refs.eyebrow.textContent = produit.type || '';
    refs.eyebrow.hidden = !produit.type;
    refs.titre.textContent = produit.title;
    refs.tagline.textContent = produit.tagline || '';
    refs.tagline.hidden = !produit.tagline;
    refs.lien.href = produit.url;

    if (produit.image) {
      refs.image.src = produit.image;
      refs.image.alt = produit.title;
      refs.image.hidden = false;
    } else {
      refs.image.hidden = true;
    }

    refs.options.innerHTML = rendreOptions(produit);

    /* première variante disponible pré-sélectionnée */
    var premiere = null;
    for (var i = 0; i < produit.variants.length; i++) {
      if (produit.variants[i].available) { premiere = produit.variants[i]; break; }
    }
    if (premiere) {
      selectionner(premiere.id);
    } else {
      choisi = null;
      refs.champId.value = '';
      refs.ajouter.disabled = true;
      refs.ajouter.textContent = refs.motRupture;
    }

    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = -scrollY + 'px';
    document.body.classList.add('vd-volet-lock');
    racine.classList.add('is-open');
    racine.removeAttribute('aria-hidden');
    refs.fermer.focus();
  }

  function fermer() {
    if (!racine || !racine.classList.contains('is-open')) return;
    racine.classList.remove('is-open');
    racine.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vd-volet-lock');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
    if (declencheur) { declencheur.focus(); declencheur = null; }
    courant = null;
    choisi = null;
  }

  /* -------------------------------------------------------- amorçage */

  function init() {
    racine = document.querySelector('[data-vd-volet]');
    if (!racine || racine.getAttribute('data-init') === '1') return;
    racine.setAttribute('data-init', '1');

    refs = {
      panneau: racine.querySelector('[data-vd-volet-panel]'),
      fermer: racine.querySelector('[data-vd-volet-close]'),
      image: racine.querySelector('[data-vd-volet-img]'),
      eyebrow: racine.querySelector('[data-vd-volet-eyebrow]'),
      titre: racine.querySelector('[data-vd-volet-title]'),
      tagline: racine.querySelector('[data-vd-volet-tagline]'),
      options: racine.querySelector('[data-vd-volet-options]'),
      champId: racine.querySelector('[data-vd-volet-id]'),
      ajouter: racine.querySelector('[data-vd-volet-add]'),
      lien: racine.querySelector('[data-vd-volet-link]'),
      motGousse: racine.getAttribute('data-mot-gousse') || '',
      motMeilleur: racine.getAttribute('data-mot-meilleur') || '',
      motRupture: racine.getAttribute('data-mot-rupture') || '',
      motAjouter: racine.getAttribute('data-mot-ajouter') || ''
    };

    /* Ouverture : clic sur le bouton d'une carte. Le JSON du produit est
       dans un <script type="application/json"> voisin, pas dans un
       attribut : pas de guillemets à échapper, pas de limite de taille. */
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-vd-volet-open]');
      if (!b) return;
      var carte = b.closest('.vd-card');
      var bloc = carte && carte.querySelector('[data-vd-volet-data]');
      if (!bloc) return;                       /* pas de données : on laisse le lien agir */
      e.preventDefault();
      try {
        ouvrir(JSON.parse(bloc.textContent), b);
      } catch (err) {
        window.location.href = b.getAttribute('data-href') || carte.querySelector('a').href;
      }
    });

    racine.addEventListener('click', function (e) {
      if (e.target.closest('[data-vd-volet-close]')) { e.preventDefault(); fermer(); return; }
      if (!e.target.closest('[data-vd-volet-panel]')) { fermer(); return; }
      var opt = e.target.closest('[data-vd-volet-opt]');
      if (opt && !opt.classList.contains('is-out')) selectionner(opt.getAttribute('data-vd-volet-opt'));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') fermer();
    });

    /* Le formulaire du volet est soumis par le gestionnaire global de
       vd-yc.js (form[action$="/cart/add"]). On ferme juste le volet
       derrière, pour que le tiroir panier apparaisse seul à l'écran. */
    racine.addEventListener('submit', function () {
      setTimeout(fermer, 60);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
